import React from 'react';
import './MarkableAvatarCard.css';

function MarkableAvatarCard({ avatarData, index, mark, onMark, isEditable, onRegenerate }) {
  const handleClick = () => {
    if (isEditable) {
      onRegenerate(index);
    } else {
      onMark(index);
    }
  };

  return (
    <div
      className={`markable-avatar-card ${mark === 'wrong' ? 'marked-wrong' : ''}`}
      onClick={handleClick}
    >
      {mark && (
        <div className={`mark-indicator mark-${mark}`}>
          {mark === 'unknown' ? '?' : 'X'}
        </div>
      )}

      <div
        className="avatar-card-display"
        dangerouslySetInnerHTML={{ __html: avatarData.svg }}
      />

      {isEditable ? (
        <div className="avatar-card-overlay">
          <span className="regenerate-icon">🎲</span>
          <span className="regenerate-text">点击刷新</span>
        </div>
      ) : (
        <div className="avatar-card-overlay">
          <span className="mark-icon">🏷️</span>
          <span className="mark-text">点击标记</span>
        </div>
      )}
    </div>
  );
}

export default MarkableAvatarCard;
